module.exports = __webpack_public_path__ + "img/Header3Kopf.f7f9beee.jpg";